module.exports = __webpack_public_path__ + "media/images/aboutus/kamill-0aaebfc1a36e799af12c5477d083f93f.png";